import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/App';
import fourNotFour from './containers/404/404';
import LoginPage from './containers/LoginPage/LoginPage';
import SSOLoginPage from './containers/LoginPage/SSOLogin';
import CustomerInfo from './containers/CustomerInformation/CustomerInfo';
import AddProducts from './containers/AddProducts/AddProducts';
import AddDiagnosticsProducts from './containers/AddProducts/AddDiagnosticsProducts';
import DeliveryAddress from './containers/DeliveryAddress/DeliveryAddress';
import DiagnosticsDeliveryAddress from './containers/DeliveryAddress/DiagnosticsDeliveryAddress';
import DiagnosticsReview from './containers/DiagnosticsReview/DiagnosticsReview';
import PrescriptionDetails from './containers/PrescriptionDetails/PrescriptionDetails';
import requireAuthentication from './components/requireAuthentication/requireAuthentication';
import SpecialitySelectionPage from './containers/DocConsult/SpecialitySelectionPage';
import DoctorSelectionPage from './containers/DocConsult/DoctorSelectionPage';
import SlotPatientPage from './containers/DocConsult/SlotPatientPage';
import ServiceSelectPackage from './containers/Services/ServiceSelectPackage';
import ServiceSlotPatient from './containers/Services/ServiceSlotPatient';

/**
 *  /
 *  /another
 **/
const routes = (<Route component={App}>
  <IndexRoute component={LoginPage} />
  <Route component={LoginPage} name="Login" path="/login" />
  <Route component={LoginPage} name="Login" path="/" />
  <Route path="/sso" component={SSOLoginPage} />
  <Route path="/customer-info" component={requireAuthentication(CustomerInfo)} />
  <Route path="/add-products" component={requireAuthentication(AddProducts)} />
  <Route path="/diagnostics/add-products" component={requireAuthentication(AddDiagnosticsProducts)} />
  <Route path="/diagnostics/select-address" component={requireAuthentication(DiagnosticsDeliveryAddress)} />
  <Route path="/diagnostics/review-order" component={requireAuthentication(DiagnosticsReview)} />
  <Route path="/select-address" component={requireAuthentication(DeliveryAddress)} />
  <Route path="/rx-availability" component={requireAuthentication(PrescriptionDetails)} />
  <Route path="/doc-consult/select-speciality" component={requireAuthentication(SpecialitySelectionPage)} />
  <Route path="/doc-consult/select-doctor" component={requireAuthentication(DoctorSelectionPage)} />
  <Route path="/doc-consult/slot-patient" component={requireAuthentication(SlotPatientPage)} />
  <Route path="/services/:serviceType/select-package" component={requireAuthentication(ServiceSelectPackage)} />
  <Route path="/services/:serviceType/slot-patient" component={requireAuthentication(ServiceSlotPatient)} />
  <Route path="*" component={fourNotFour} />
</Route>);

export default routes;
